import { useGetList, Loading } from 'react-admin';
import Typography from "@material-ui/core/Typography";

const GetUltimoCalcolo = ({ tblQuizId }) => {
    const { data: calcolo, isLoading, error } = useGetList('update-quiz-punteggio', { filter: { tblQuizId: tblQuizId } });

    if (isLoading) { return <Loading />; }
    if (error) { return <p>ERROR</p>; }
    if (!calcolo || calcolo.length === 0) { return <p></p>; } // Aggiungi questa condizione

    return (
        <>
            <Typography variant="subtitle1" component="div">
                <strong>Esito calcolo:</strong> {calcolo[0].status}
            </Typography>
            <Typography variant="subtitle1" component="div">
                <strong>Data e ora ultimo calcolo :</strong> {formatDateTime(calcolo[0].createdAt)}
            </Typography>
        </>
    );
};


const formatDateTime = (createdAt) => {
    const date = new Date(createdAt); // Converti la stringa in un oggetto Data

    // Ottieni i vari componenti della data e dell'ora
    const day = date.getDate().toString().padStart(2, '0'); // Aggiungi lo zero iniziale se necessario
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Mese inizia da zero, quindi aggiungi 1
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    // Formatta la data e l'ora nel formato desiderato
    const formattedDateTime = `${day}/${month}/${year} ${hours}:${minutes}`;

    return formattedDateTime;
};


export default GetUltimoCalcolo;